import axios from 'axios';
import { requestInterceptor, responseInterceptor } from './interceptors';

const baseURL = import.meta.env.VITE_API_URL as string;

// Single V3 API instance
export const api = axios.create({
  baseURL: `${baseURL}`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Apply interceptors
api.interceptors.request.use(requestInterceptor);
api.interceptors.response.use(undefined, responseInterceptor);

// Export all service modules
export * from './auth.service';
export * from './briefings.service';
export * from './categories.service';
export * from './companies.service';
export * from './contact.service';
export * from './data.service';
export * from './financials.service';
export * from './studies.service';
export * from './study-year-categories.service';
export * from './study-year-category-companies.service';
export * from './study-year-companies.service';
export * from './study-year.service';
export * from './user.service';
